export const scrollIntoView = (ref: any) => {
  ref?.current?.scrollIntoView({ behavior: 'smooth' });
};

export default {
  scrollIntoView,
};
